import React from "react";
import { Link } from "react-router-dom";
import { Wordmark } from "@/components/Logo";
import { NAV_LINKS } from "@/components/UI";

export function Footer() {
  return (
    <footer className="bg-ccpm-charcoal text-ccpm-ivory" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <Wordmark light />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-ccpm-olive-soft font-light">
              The Canadian Council for Paramedical Micropigmentation is establishing the national standard for
              restorative paramedical micropigmentation — distinct from cosmetic permanent makeup.
            </p>
            <p className="mt-6 text-xs text-white/40">Restorative care for people affected by cancer, surgery, trauma, congenital conditions and skin disorders.</p>
          </div>
          <div className="lg:col-span-4 lg:col-start-7">
            <h4 className="overline text-ccpm-olive-soft mb-5">Navigate</h4>
            <ul className="grid grid-cols-2 gap-y-3 gap-x-6">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-ccpm-ivory/80 hover:text-ccpm-ivory transition-colors" data-testid={`footer-${l.to.slice(1)}`}>{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="lg:col-span-2">
            <h4 className="overline text-ccpm-olive-soft mb-5">Access</h4>
            <ul className="space-y-3">
              <li><Link to="/consultation" className="text-sm text-ccpm-ivory/80 hover:text-ccpm-ivory" data-testid="footer-consultation">Public Consultation</Link></li>
              <li><Link to="/textbook" className="text-sm text-ccpm-ivory/80 hover:text-ccpm-ivory" data-testid="footer-textbook">Upcoming Textbook</Link></li>
              <li><Link to="/registry" className="text-sm text-ccpm-ivory/80 hover:text-ccpm-ivory">The Registry</Link></li>
              <li><Link to="/contact" className="text-sm text-ccpm-ivory/80 hover:text-ccpm-ivory">Contact & Complaints</Link></li>
              <li><Link to="/admin/login" className="text-sm text-ccpm-ivory/50 hover:text-ccpm-ivory" data-testid="footer-admin">Admin</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-4 text-xs text-white/40">
          <p>© {new Date().getFullYear()} Canadian Council for Paramedical Micropigmentation. All rights reserved.</p>
          <p>Setting Canada's National Standard for Restorative Paramedical Micropigmentation.</p>
        </div>
      </div>
    </footer>
  );
}
